import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  encryptData(data: string, key: string): string {
    const encryptedData = CryptoJS.AES.encrypt(data, key).toString();
    return encryptedData;
  }

  decryptData(encryptedData: string, key: string): string {
    const decryptedData = CryptoJS.AES.decrypt(encryptedData, key).toString(
      CryptoJS.enc.Utf8
    );
    return decryptedData;
  }
}
